module.exports = {
	"id": "PH",
	"name": "Philippines",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.005871,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.017613,
			"11": 0.029355,
			"12": 0.017613,
			"13": 0.005871,
			"14": 0.011742,
			"15": 0.005871,
			"16": 0.017613,
			"17": 0.011742,
			"18": 0.035226,
			"19": 0.017613,
			"20": 0.017613,
			"21": 0.023484,
			"22": 0.046968,
			"23": 0.029355,
			"24": 0.029355,
			"25": 0.041097,
			"26": 0.05871,
			"27": 0.041097,
			"28": 0.052839,
			"29": 0.046968,
			"30": 0.046968,
			"31": 0.193743,
			"32": 0.041097,
			"33": 0.140904,
			"34": 0.052839,
			"35": 0.064581,
			"36": 0.05871,
			"37": 0.046968,
			"38": 0.052839,
			"39": 0.093936,
			"40": 0.088065,
			"41": 0.05871,
			"42": 0.064581,
			"43": 0.217227,
			"44": 0.193743,
			"45": 0.193743,
			"46": 0.299421,
			"47": 0.317034,
			"48": 0.29355,
			"49": 2.612595,
			"50": 0.434454,
			"51": 1.373814,
			"52": 1.191813,
			"53": 29.583969,
			"54": 6.352422,
			"55": 0.287679,
			"56": 0.070452,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011742,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.005871,
			"11": 0.011742,
			"12": 0.017613,
			"13": 0.005871,
			"14": 0.005871,
			"15": 0.011742,
			"16": 0.011742,
			"17": null,
			"18": 0.005871,
			"19": 0.005871,
			"20": 0.011742,
			"21": 0.017613,
			"22": 0.011742,
			"23": 0.011742,
			"24": 0.011742,
			"25": 0.017613,
			"26": 0.011742,
			"27": 0.011742,
			"28": 0.011742,
			"29": 0.023484,
			"30": 0.023484,
			"31": 0.023484,
			"32": 0.023484,
			"33": 0.029355,
			"34": 0.023484,
			"35": 0.029355,
			"36": 0.029355,
			"37": 0.035226,
			"38": 0.082194,
			"39": 0.064581,
			"40": 0.05871,
			"41": 0.064581,
			"42": 0.052839,
			"43": 0.211356,
			"44": 0.088065,
			"45": 0.140904,
			"46": 0.082194,
			"47": 0.422712,
			"48": 0.364002,
			"49": 3.252534,
			"50": 0.287679,
			"51": 0.011742,
			"52": null,
			"3.5": null,
			"3.6": 0.017613
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": 0.005871,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.011742,
			"35": null,
			"36": 0.017613,
			"37": 0.076323,
			"38": 0.011742,
			"39": 0.011742,
			"40": 0.211356,
			"41": 0.029355,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011742
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.011742,
			"6": 0.005871,
			"7": 0.029355,
			"8": 0.093936,
			"9": 0.105678,
			"10": 0.375744,
			"3.1": null,
			"3.2": null,
			"5.1": 0.029355,
			"6.1": 0.017613,
			"7.1": null,
			"9.1": 0.322905
		},
		"ios_saf": {
			"8": 0,
			"10": 5.02700077352,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.135471853976,
			"8.1-8.4": 0.250278509888,
			"9.0-9.2": 0.119398922148,
			"9.3": 1.82159894047
		},
		"android": {
			"3": 0,
			"4": 0.0710252015504,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0088781501938,
			"4.1": 0.25619804845,
			"4.2-4.3": 0.640495121124,
			"4.4": 1.46869970349,
			"4.4.3-4.4.4": 1.48138277519
		},
		"ie": {
			"6": null,
			"7": 0.0532781052632,
			"8": 0.331508210526,
			"9": 0.0769572631579,
			"10": 0.0887968421053,
			"11": 1.58650357895,
			"5.5": null
		},
		"op_mob": {
			"0": 0.518808600675,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0144113500187
		},
		"edge": {
			"12": 0.082194,
			"13": 0.205485,
			"14": 0.287679
		},
		"ie_mob": {
			"10": 0.0643193521127,
			"11": 0.261871647887
		},
		"bb": {
			"7": 0.024774,
			"10": null
		},
		"samsung": {
			"0": 1.659858
		},
		"and_uc": {
			"0": 1.668116
		},
		"op_mini": {
			"0": 6.98981804931
		},
		"and_chr": {
			"0": 21.764004
		},
		"and_ff": {
			"0": 0.024774
		}
	},
	"total": 99.006516
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PH.json
 ** module id = 621
 ** module chunks = 0
 **/